<div class="table-wrapper">
  <ts-table
    [columnDefs]="colDefs"
    [rowData]="activities"
    [gridOptions]="gridOptions"
    [loading]="loading"
    [autoHeight]="false"
  >
  </ts-table>
</div>
